import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { useOrganizationTaskGroups } from "@api/organizationTaskGroup.api";
import { formatWorkspaceMemberFilterLabel } from "@components/pageHeader/filters/workspaceMemberFilter.lib";
import { ASSIGNEE_ROLE_LABEL } from "@components/settings/OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import { getTaskTypeLabel } from "../Tabs/OrgTaskTemplateFilters/orgTaskTemplateFilterOptions";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const OrgTaskTemplateTypeFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const types = filters.orgTaskTemplateTypes ?? [];
    return formatFilterLabel(types.map(getTaskTypeLabel));
};

export const OrgTaskTemplateAssigneeRoleFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const roles = filters.orgTaskTemplateAssigneeRoles ?? [];
    return formatFilterLabel(roles.map((role) => ASSIGNEE_ROLE_LABEL[role]));
};

export const OrgTaskTemplateGroupFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const { data: taskGroups = [] } = useOrganizationTaskGroups();
    const { orgTaskTemplateGroupIds } = filters;

    const labels = useMemo(
        () =>
            taskGroups
                .filter((group) => orgTaskTemplateGroupIds?.includes(group.id))
                .map((group) => group.name),
        [taskGroups, orgTaskTemplateGroupIds],
    );

    return formatFilterLabel(labels);
};

export const OrgTaskTemplateCreatedByFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const { data: members } = useCurrentOrganizationMembers();

    const label = formatWorkspaceMemberFilterLabel({
        userIds: filters.orgTaskTemplateCreatedByUserIds,
        members,
    });

    return label ? <span>{label}</span> : null;
};
